import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useDealerAdmin } from '../contexts/DealerAdminContext';
import { ROUTES } from '../utils/constants';
import { isOperatorShellRole, resolveEffectiveRole } from '../utils/sessionRole';
import { readSupportedTenantSession } from '../pages/Admin/supportedTenantsSession';

export const useRoleGuard = (allowedRoles, fallbackRoute = '/unauthorized') => {
  const { currentUser, userClaims, userData, authReady } = useAuth();
  const dealerAdmin = useDealerAdmin();
  const navigate = useNavigate();

  const role = resolveEffectiveRole(userClaims?.role, userData?.role);
  const hasRoleAccess = !!role && allowedRoles.includes(role);
  const dealerBypass = Boolean(dealerAdmin.active);
  const supportBypass = Boolean(readSupportedTenantSession()?.tenantId) && !dealerBypass;
  const hasAccess = hasRoleAccess || dealerBypass || supportBypass;
  const deniedFallback = isOperatorShellRole(role) ? ROUTES.HOME_LAUNCHER : fallbackRoute;

  useEffect(() => {
    if (dealerBypass || supportBypass) return;
    if (authReady && currentUser && !hasAccess && role !== undefined) {
      navigate(deniedFallback, { replace: true });
    }
  }, [authReady, currentUser, dealerBypass, supportBypass, hasAccess, navigate, deniedFallback, role]);

  return authReady && role ? hasAccess : false;
};

export default useRoleGuard;
